;(function() {
  'use strict'

  angular.module('core.kitListSelect', [])
})()
